// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ABIm8b7Kez1t5PGEvBJk {
  color: var(--act-dark);
  border-color: var(--act-dark) !important;
}

.T1dwId_7PEV_grWVJQq_ {
  margin-bottom: 6px;
}

.tPpwPbYG6Xcm9BHHBxze {
  width: 65%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 20px;
}

.P2lH1WwhUVj4fRkPle0W {
  display: flex;
  gap: 8px;
}

.eiNm5Fb6BWknJeYyE_Mv {
  color: var(--act-dark);
}

.afnfiXnePSrbuKmwEveT {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.fCkSo53ZxDkKCrLDJJcM {
  cursor: pointer;
}

.yaYxaaJLtXEU3DYBh9Ud {
  font-family: var(--font-stack-full-heavy);
  font-size: 16px;
  color: var(--grey-color-90);
  line-height: 24px;
}

.oUH2PJPl9ziP2bQ2p5Qn {
  display: flex;
  gap: 8px;
  padding: 16px 24px;
  background-color: #ffc6c6;
  border-radius: 24px;
}

.i8AUFzgd7NK69vnU4OVS {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--act-dark);
  display: flex;
  justify-content: center;
  align-items: center;
}

.W5yXlSlxwf8lahLaVzJc {
  color: var(--background-color);
}

.e1HlcZGOFdVVWSnff35X {
  font-family: var(--font-stack-full-medium);
  font-size: 18px;
  line-height: 24px;
  color: var(--act-dark);
}

.EPF8Ws35WSJGBgPA3ogh {
  pointer-events: none;
  opacity: 0.5;
  background-color: #f0f0f0;
}

.SOswzAlBl92N7w5tvtkx {
  width: 36px;
  height: 36px;
  background-color: var(--grey-color-10);
  padding: 8px;
  border-radius: 24px;
  cursor: pointer;
}

.SOswzAlBl92N7w5tvtkx:hover {
  background-color: #e8eaed;
}`, "",{"version":3,"sources":["webpack://./src/components/TalentReview/TalentReview.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,wCAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,yCAAA;EACA,eAAA;EACA,2BAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,0CAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AACF;;AAEA;EACE,oBAAA;EACA,YAAA;EACA,yBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".formError {\n  color: var(--act-dark);\n  border-color: var(--act-dark) !important;\n}\n\n.createNineboxNameBox {\n  margin-bottom: 6px;\n}\n\n.resetButtonWrapper {\n  width: 65%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: absolute;\n  bottom: 20px;\n}\n\n.editConfirmHeaderWrapper {\n  display: flex;\n  gap: 8px;\n}\n\n.editConfirmHeaderIcon {\n  color: var(--act-dark);\n}\n\n.editPencilIconContainer {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.editPencilIcon {\n  cursor: pointer;\n}\n\n.filteredLeaderCount {\n  font-family: var(--font-stack-full-heavy);\n  font-size: 16px;\n  color: var(--grey-color-90);\n  line-height: 24px;\n}\n\n.nineBoxLeaderCountErrorMsgContainer {\n  display: flex;\n  gap: 8px;\n  padding: 16px 24px;\n  background-color: #ffc6c6;\n  border-radius: 24px;\n}\n\n.exclamationIconContainer {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: var(--act-dark);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.exclamationIcon {\n  color: var(--background-color);\n}\n\n.leaderCountErrorMessage {\n  font-family: var(--font-stack-full-medium);\n  font-size: 18px;\n  line-height: 24px;\n  color: var(--act-dark);\n}\n\n.disableIcons {\n  pointer-events: none;\n  opacity: 0.5;\n  background-color: #f0f0f0;\n}\n\n.nineBoxDeleteIcon {\n  width: 36px;\n  height: 36px;\n  background-color: var(--grey-color-10);\n  padding: 8px;\n  border-radius: 24px;\n  cursor: pointer;\n}\n\n.nineBoxDeleteIcon:hover {\n  background-color: #e8eaed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formError": `ABIm8b7Kez1t5PGEvBJk`,
	"createNineboxNameBox": `T1dwId_7PEV_grWVJQq_`,
	"resetButtonWrapper": `tPpwPbYG6Xcm9BHHBxze`,
	"editConfirmHeaderWrapper": `P2lH1WwhUVj4fRkPle0W`,
	"editConfirmHeaderIcon": `eiNm5Fb6BWknJeYyE_Mv`,
	"editPencilIconContainer": `afnfiXnePSrbuKmwEveT`,
	"editPencilIcon": `fCkSo53ZxDkKCrLDJJcM`,
	"filteredLeaderCount": `yaYxaaJLtXEU3DYBh9Ud`,
	"nineBoxLeaderCountErrorMsgContainer": `oUH2PJPl9ziP2bQ2p5Qn`,
	"exclamationIconContainer": `i8AUFzgd7NK69vnU4OVS`,
	"exclamationIcon": `W5yXlSlxwf8lahLaVzJc`,
	"leaderCountErrorMessage": `e1HlcZGOFdVVWSnff35X`,
	"disableIcons": `EPF8Ws35WSJGBgPA3ogh`,
	"nineBoxDeleteIcon": `SOswzAlBl92N7w5tvtkx`
};
export default ___CSS_LOADER_EXPORT___;
